<template>
  <div class="product__option product__current-user">
    <UserIcon /> {{ numberOfPeople }}
    {{ pluralize(numberOfPeople, 'people has', 'peoples have') }} this item in
    their carts right now.
  </div>
</template>
<script lang="ts" setup>
import { pluralize } from '@/utils/language'
import UserIcon from '@/assets/images/icons/user-icon.svg'
import { onMounted, onUnmounted, Ref, ref } from 'vue'
const numberOfPeople = ref(0)
const interval: Ref<any> = ref(0)
const max = 28
const min = 1
const intervalTime = 10000
onMounted(() => {
  numberOfPeople.value = 5 + Math.floor(Math.random() * 10)
  interval.value = setInterval(() => {
    numberOfPeople.value += -3 + Math.floor(Math.random() * 6)
    if (numberOfPeople.value < min) numberOfPeople.value = min
    if (numberOfPeople.value > max) numberOfPeople.value = max
  }, intervalTime)
})
onUnmounted(() => {
  if (interval.value) {
    clearInterval(interval.value)
  }
})
</script>

<style lang="scss">
.product__current-user {
  display: flex;
  align-items: center;

  svg {
    width: 1em;
    height: 1em;
    margin-right: 0.5em;
  }
}
</style>
